export default "__VITE_ASSET__CBrDM7bQ__"